// extracted by mini-css-extract-plugin
export default {"centeredDiv":"_975b061f"};